import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { RevisionsUIProvider } from './RevisionsContextProvider';
// import {default as RevisionsList} from './Revisions';
const RevisionsList = React.lazy(() => import('./Revisions'));

function Revisions(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست تغییرات رویداد</PageTitle>
      </PageHeader>
      <Suspense fallback={<Loading />}>
        <RevisionsUIProvider>
          <RevisionsList {...props} />
        </RevisionsUIProvider>
      </Suspense>
    </Page>
  );
}

export default Revisions;
